export enum RxVersion {
	CaseTypeFlow = 0,
	ProcedureFlow = 1
}